import { z } from 'zod';
/**
 * 멱등키 (Idempotency Key) 브랜드 타입.
 *
 * 정책 (ARCHITECTURE §5.2, STACK.md Pitfall 4):
 * - UUID v4 형식만 허용 — Toss Payments 정책 및 예측 불가능성 보장.
 * - v1(시간)·v3(MD5)·v5(SHA-1) 등은 예측 가능하므로 거부.
 * - plain `string` 과 브랜드 타입으로 격리되어 일반 식별자와 혼용 차단.
 *
 * 사용처:
 * - Toss PG·Payout API 의 `Idempotency-Key` 헤더 값.
 * - `outbox_events.idempotency_key` 컬럼 값 (UNIQUE 제약).
 * - `@loop/events/idempotency` 의 `deriveIdempotencyKey` 는 SHA-256 기반 결정론적 파생
 *   — 해당 키는 UUID 형식이 아니므로 본 스키마 대상 아님 (별도 파이프라인).
 */
/** UUID v4 엄격 정규식 — 버전 nibble = 4, variant nibble = 8/9/A/B */
const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const idempotencyKeySchema = z
    .string()
    .refine((v) => UUID_V4_REGEX.test(v), {
    message: 'IdempotencyKey 는 UUID v4 형식이어야 합니다',
})
    .brand();
/** 런타임 type guard — 검증 없이 형식만 체크하고 싶을 때 */
export function isIdempotencyKey(v) {
    return typeof v === 'string' && UUID_V4_REGEX.test(v);
}
//# sourceMappingURL=idempotency.js.map